
import React from 'react';
import { Provider } from 'react-redux'

import { setStore } from '../../core';

import { configureStore } from '../store';
import Root from './Root';
import OperationStatus from '../../common/client/components/OperationStatus';

/**
 * Application root component.
 *
 * @param {Object} props
 * @param {React.Component} props.appComponent - application component which will be rendered
 * @param {string} props.project - project ID which will be used
 * @param {React.Component} [props.appLayoutComponent] - component for layout definition
 * @param {Object} [props.appLayoutProps] - properties for layout definition component
 * @param {Boolean} [props.anonymous=false] - specify if anonymous access is enabled or is required authorization
 */
const App = (props) => {
    const store = configureStore(props.anonymous);
    setStore(store);
    return (
        <Provider store={store}>
            <Root {...props}/>
            <OperationStatus />
        </Provider>
    );
};

export default App;
